module.exports = __webpack_public_path__ + "static/year2010-921ed801d51389b993df2917a8a64f34.jpg";